export const thank_you_pages_apis = {
  get_thank_you_pages_list: "marketing/thankyou/page/list",
  get_thank_you_page_templates_list: "marketing/thankyou/page/templates",
  create_thank_you_page: "marketing/thankyou/page/add",
  update_thank_you_page: (thankYouPageUuid) =>
    `marketing/thankyou/page/update/${thankYouPageUuid}`,
  get_thank_you_page_details: (thankYouPageUuid) =>
    `marketing/thankyou/page/details/${thankYouPageUuid}`,
  delete_thank_you_page: "marketing/thankyou/page/delete",
  publish_thank_you_page: (thankYouPageUuid) =>
    `marketing/thankyou/page/publish/${thankYouPageUuid}`,
  duplicate_thank_you_page: "marketing/thankyou/page/duplicate",
  unpublish_thank_you_page: "marketing/thankyou/page/unpublish",
};
